(() => {
  if (window.AGSliderVisibility) return;

  window.AGSliderVisibility = class {
    constructor(element, onReady) {
      this.element = element;
      this.onReady = onReady;
      this.ready = typeof window.IntersectionObserver !== 'function' || Boolean(window.Shopify?.designMode);
      this.activate = this.activate.bind(this);
      if (this.ready) return;

      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.activate();
      }, { rootMargin: '300px 0px' });
      this.observer.observe(element);
      element.addEventListener('focusin', this.activate);
      element.addEventListener('pointerdown', this.activate, true);
    }

    activate() {
      if (this.ready || !this.onReady) return;
      this.ready = true;
      const onReady = this.onReady;
      this.disconnect();
      onReady();
    }

    disconnect() {
      this.observer?.disconnect();
      this.observer = null;
      this.element.removeEventListener('focusin', this.activate);
      this.element.removeEventListener('pointerdown', this.activate, true);
      this.onReady = null;
    }
  };
})();
